<template>
  <div style="margin-top:10px;background:#fff;overflow: hidden;border-radius: 5px;padding: 10px;">
    <div style="margin-bottom:10px;">
      <a-button type="danger" icon="plus" class="bt-button" style="float:right;" @click="$refs.editTeam.show(null)">新增球队</a-button>
      <a-radio-group :value="valData.programId" @change="changeProgram">
        <a-radio-button :value="0">
          默认小队
        </a-radio-button>
        <a-radio-button :value="item.programId"  v-for="(item, index) in programList" :key="index">
          {{ item.programName }}
        </a-radio-button>
      </a-radio-group>
    </div>
    <a-table :columns="columns" :data-source="data" :rowKey='record=>record.id' bordered :pagination="false">
      <span slot="teamLogo" slot-scope="text">
        <img style="width:64px;height:64px;border-radius:5px;" :src="text" />
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button-group size="small" v-if="record.programId !== 0">
          <a-button type="dashed" icon="edit" @click="$refs.editTeam.show(record)">编辑</a-button>
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => deleteTeam(record.id)"
          >
            <a-button type="danger" icon="delete">删除</a-button>
          </a-popconfirm>
        </a-button-group>
        <span v-else>
          默认小队名称为机构简称<br/>
          若修改，请修改机构简称
        </span>
      </span>
    </a-table>
    <EditTeam ref="editTeam" @ok="refreshAuth"/>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
import EditTeam from './modal/EditTeam'
export default {
  name: 'CenterAuth',
  components: {
    EditTeam
  },
  created () {
    this.initList()
    this.findProgram()
  },
  mounted () {},
  data () {
    return {
      matchFun: matchFun,
      valData: {
        agencyId: this.$route.query.agencyId,
        programId: 0
      },
      queryParam: {},
      programList: [],
      columns: [{
        title: this.$t('队伍logo'),
        dataIndex: 'teamLogo',
        align: 'center',
        scopedSlots: { customRender: 'teamLogo' }
      }, {
        title: this.$t('队伍名称'),
        dataIndex: 'teamName',
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
      }],
      data: []
    }
  },
  methods: {
    initList () {
      this.data = []
      this.$api.join.getMatchTeam(this.valData).then(res => {
        if (res.status === 0) {
          res.data.forEach(element => {
            if (element.programId === this.valData.programId) {
              this.data.push(element)
            }
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    findProgram () {
      this.programList = []
      this.$api.join.getProgram({agencyId: this.$route.query.agencyId}).then(res => {
        if (res.status === 0) {
          this.programList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    changeProgram (e) {
      this.valData.programId = e.target.value
      this.initList()
    },
    refreshAuth () {
      this.initList()
    },
    deleteTeam (id) {
      this.$api.join.delMatchTeam({id: id}).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.initList()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.BottomButton{
    margin: 50px 0;
    text-align: center;
    div{
        background-color: #d60701;
        padding: 10px 25px;
        width: 160px;
        color: #fff;
        margin: 0 auto;
        border-radius: 2px;
        cursor: pointer;
        text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/center/CenterTeam.vue